import React, { useCallback, useRef, useEffect } from 'react';
import type { PlatformFrameProps } from '@wix/editor-platform-host-integration-apis';

export const PlatformFramePanel: React.FC<PlatformFrameProps> = ({
  appDefinitionId,
  getWorkerManager,
  displayName,
  url,
  ...props
}) => {
  const frameRef = useRef<HTMLIFrameElement | null>();
  const setRef = useCallback((ref: HTMLIFrameElement | null) => {
    frameRef.current = ref;
  }, []);

  const initializeFrame = useCallback(() => {
    const isValidProps = () => appDefinitionId && frameRef.current;

    if (isValidProps()) {
      if (typeof getWorkerManager !== 'function') {
        console.warn('PlatformFrame - getWorkerManager is not a function');
      } else {
        getWorkerManager().then((workerManager) => {
          // Double-check validity after async operation
          if (workerManager && isValidProps()) {
            void workerManager.connectFrame(appDefinitionId, frameRef.current!);
          }
        });
      }
    }
  }, [appDefinitionId, getWorkerManager]);

  useEffect(() => {
    initializeFrame();
  }, [initializeFrame]);

  return (
    <iframe
      width="100%"
      height="100%"
      data-aid="platform-iframe"
      data-platform-consumer-type="panel-builder"
      ref={setRef}
      {...props}
      src={url}
      title={displayName || ''}
    />
  );
};
